<!--
 * @Description: qa pc端
 * @Author:  单珊珊
 * @Date: 2024-07-24 10:43:13
 * @LastEditTime: 2024-09-10 11:59:39
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <page-header>{{'常见问题' | dealLanguage('FAQ')}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="flex-wrapper">
      <div class="flex-left">
        <Affix :offset-top="94" v-if="qa_list.length > 0">
          <Anchor :affix="false" :bounds="100" :offset-top="110" :scroll-offset="80">
            <AnchorLink v-for="item, index in qa_list" :key="item.id" :href="'#' + item.id" :title="item.title | dealLanguage(item.enTitle)" />
          </Anchor>
        </Affix>
      </div>
      <div class="flex-right">
        <div class="qa-list">
          <div class="qa-item" v-for="item in qa_list" :id=" item.id" :key="item.id">
            <p class="q-title">
              Q：{{item.title | dealLanguage(item.enTitle)}}
            </p>
            <div class="a-content" v-html="item.summary" v-if="language == 'zh'"></div>
            <div class="a-content" v-html="item.enSummary" v-else></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/pc/pageHeader.vue'
import { detailcontent } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '常见问题' : 'FAQ',
    }
  },
  data() {
    return {
      qa_list: [],
      loading: true,
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      user_key: (state) => state.user_key,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },

  created() {
    this.detailcontent()
  },

  mounted() {},

  methods: {
    async detailcontent() {
      this.loading = true
      let res = await detailcontent({
        actId: this.activityId,
        modeNames: ['faq'],
      })
      if (res.code == 0) {
        this.$set(this.$data, 'qa_list', res.data.faq)
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.loading = false
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.main-container
  position: relative
.flex-wrapper
  .flex-right
    .qa-item
      padding-bottom 30px
      .q-title
        width 100%
        background #80A4FF
        padding 8px 20px
        height fit-content
        font-size 18px
        color #FFFFFF
        margin-bottom 20px
      >>>.a-content
        font-size 16px
        color #3D3D3D
        line-height 30px
        ol
          list-style auto
          padding-left 20px
          li
            list-style auto
        ul
          list-style disc
          padding-left 20px
          li
            list-style disc
        a
          color #2d7bc5
        em
          font-style italic
        img
          margin 0 auto
          display block
          max-width 100% !important
          max-height 100% !important
        span
          max-width 100% !important
          padding 0
        p
          max-width 100% !important
          margin 0
          font-size 16px
          font-weight 500
          color #1D2129
          line-height 30px
          text-align justify
        table
          width 100%
          td
            border 1px solid #e5e5e5
        iframe
          width 100% !important
          height 200px !important
        section
          max-width 100% !important
          p
            margin inherit
            font-size inherit
            font-weight inherit
            color inherit
            line-height inherit
            text-align inherit
        video
          max-width 100% !important
          max-height 600px !important
          background #000
        .toastui-editor-ww-code-block-highlighting
          overflow auto
          max-width 100% !important
</style>